import { AXIOSMETHOD } from "constants/enum_axios_methods";
import { IComment } from "interfaces/interface_comment";
import apiBuilder from "./apiBuilder";
import { IPendingPatients } from "interfaces/interface_pendingPatients";
import { IEmploymentRequest } from "interfaces/interface_employmentRequest";

const SUBBASEURL = "/user";

type TPaginationParams = { page: number; pageSize?: number; locale?: string };
type TWorkerParams = {
  page: number;
  pageSize?: number;
  locale?: string;
  DepartmentId?: number;
  Search: string;
};
type TDoctorParams = {
  page: number;
  pageSize?: number;
  locale?: string;
  SpecialtyId?: number;
  Search: string;
};
type TClinicParams = {
  locale?: string;
  SpecialtyId?: number;
  Search: string;
};
type TIDParams = {
  locale?: string;
  id: number;
};
type TDiseasParams = {
  page: number;
  pageSize?: number;
  locale?: string;
  Search: string;
  StartWith: string;
};
type TLifeStyleParams = {
  page: number;
  pageSize?: number;
  locale?: string;
  CategoryId?: any;
  Search: string;
  Sort?: number;
};
type TMedicineParams = {
  page: number;
  pageSize?: number;
  locale?: string;
  Search: string;
  StartWith: string;
};
type TTypeParams = {
  locale?: string;
  Type: 0 | 1 | 2 | 3;
};
// Type : 0 -> بیماران بین الملل
// Type : 1 -> (اتاق‌های اختصاصی)واحد مهدکودک
// Type : 2 -> واحد حامیان بیمار
// Type : 3 -> واحد SPA

export type Category = { id: number; name: string };
interface TServicesParams extends TLifeStyleParams {}

type IHospitalNewsParams = {
  InnovationNews: boolean;
  page: number;
  pageSize: number;
  Search?: string;
  Sort: 0 | 1;
  locale?: string;
};
//--------------------------------------------------------------------------------------------------

export const getMMainPage = (locale?: string) => {
  let url = `${SUBBASEURL}/mainPage`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const addMComment = (data: IComment) => {
  let url = `${SUBBASEURL}/comment`;
  let temp = data;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.POST).setBody(temp).call();
};

//--------------------------------------------------------------------------------------------------

export const getAboutIntroduction = (locale?: string) => {
  let url = `${SUBBASEURL}/introduction`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getAboutMission = (locale?: string) => {
  let url = `${SUBBASEURL}/ourMission`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getAboutVision = (locale?: string) => {
  let url = `${SUBBASEURL}/vision`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getOurPolicy = (locale?: string) => {
  let url = `${SUBBASEURL}/ourPolicy`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getAboutExperiences = (params: TPaginationParams) => {
  let url = `${SUBBASEURL}/patientExperiences`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

//--------------------------------------------------------------------------------------------------

export const getAboutAchivements = (params: TPaginationParams) => {
  let url = `${SUBBASEURL}/achievement`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

//--------------------------------------------------------------------------------------------------

export const getAboutWorkers = (params: TWorkerParams) => {
  let url = `${SUBBASEURL}/worker`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

//--------------------------------------------------------------------------------------------------

export const getVisitorInsurance = (params: TPaginationParams) => {
  let url = `${SUBBASEURL}/insurance`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

//--------------------------------------------------------------------------------------------------

export const getVisitorTariff = (params: TPaginationParams) => {
  let url = `${SUBBASEURL}/tariff`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

//--------------------------------------------------------------------------------------------------

export const getVisitorMeetingGuide = (locale?: string) => {
  let url = `${SUBBASEURL}/meetingGuide`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const getVisitorPatientAdmissionGuide = (locale?: string) => {
  let url = `${SUBBASEURL}/patientAdmissionGuide`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const getVisitorPatientGuide = (locale?: string) => {
  let url = `${SUBBASEURL}/patientGuide`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getVisitorContactUs = (locale?: string) => {
  let url = `${SUBBASEURL}/contactUs`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getDoctors = (params: TDoctorParams) => {
  let url = `${SUBBASEURL}/doctor`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

export const getDoctorsDetail = (params: TIDParams) => {
  let url = `${SUBBASEURL}/doctor/${params.id}`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(params.locale);
};

//--------------------------------------------------------------------------------------------------

export const getDepartmentList = (locale?: string) => {
  let url = `${SUBBASEURL}/department/list`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const getDepartments = (locale?: string) => {
  let url = `${SUBBASEURL}/department`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const getDepartmentOne = (params: TIDParams) => {
  let url = `${SUBBASEURL}/department/${params.id}`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(params.locale);
};

//--------------------------------------------------------------------------------------------------

export const getSpecialties = (locale?: string) => {
  let url = `${SUBBASEURL}/specialty`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getVisitUnitInfo = (params: TTypeParams) => {
  let url = `${SUBBASEURL}/unit`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

//--------------------------------------------------------------------------------------------------

export const getVisitorFaq = (params: TPaginationParams) => {
  let url = `${SUBBASEURL}/faq`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

//--------------------------------------------------------------------------------------------------

export const getVisitorClinic = (params: TClinicParams) => {
  let url = `${SUBBASEURL}/clinic`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

//--------------------------------------------------------------------------------------------------

export const getDiseases = (params: TDiseasParams) => {
  let url = `${SUBBASEURL}/illness`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

export const getDiseasesOne = (params: TIDParams) => {
  let url = `${SUBBASEURL}/illness/${params.id}`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

//--------------------------------------------------------------------------------------------------

export const getLifeStyles = (params: TLifeStyleParams) => {
  let url = `${SUBBASEURL}/lifeStyle`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

export const getLifeStylesOne = (params: TIDParams) => {
  let url = `${SUBBASEURL}/lifeStyle/${params.id}`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

export const getLifeStylesCategory = (locale?: string) => {
  let url = `${SUBBASEURL}/lifeStyle/category`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getMedicines = (params: TMedicineParams) => {
  let url = `${SUBBASEURL}/medicine`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

export const getMedicinesOne = (params: TIDParams) => {
  let url = `${SUBBASEURL}/medicine/${params.id}`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

//--------------------------------------------------------------------------------------------------

export const getStaffTraining = (params: TLifeStyleParams) => {
  let url = `${SUBBASEURL}/staffTraining`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

export const getStaffTrainingOne = (params: TIDParams) => {
  let url = `${SUBBASEURL}/staffTraining/${params.id}`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

export const getStaffTrainingCategory = (locale?: string) => {
  let url = `${SUBBASEURL}/staffTraining/category`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getServicesCategories = (locale?: string) => {
  let url = `${SUBBASEURL}/service/category`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const getServices = (params: TServicesParams) => {
  let url = `${SUBBASEURL}/service`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

export const getOneService = (params: TIDParams) => {
  let url = `${SUBBASEURL}/service/${params.id}`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};
//--------------------------------------------------------------------------------------------------

export const getTests = (params: TMedicineParams) => {
  let url = `${SUBBASEURL}/test`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};

export const getTestOne = (params: TIDParams) => {
  let url = `${SUBBASEURL}/test/${params.id}`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(params.locale);
};
//-------------------------------------------------------------------------------------------------
export const addPendingPatients = (data: IPendingPatients) => {
  let url = `${SUBBASEURL}/pending-patients`;
  let temp = data;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.POST).setBody(temp).call();
};
//-------------------------------------------------------------------------------------------------
export const addEmploymentRequest = (data: IEmploymentRequest) => {
  let url = `${SUBBASEURL}/employmentRequest`;
  let temp = data;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.POST).setBody(temp).call();
};
//-------------------------------------------------------------------------------------------------
export const getHospitalNews = ({
  InnovationNews,
  page,
  pageSize,
  Search,
  Sort,
  locale,
}: IHospitalNewsParams) => {
  let url = `${SUBBASEURL}/hospitalNews`;

  let params = { InnovationNews, page, pageSize, Search, Sort };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

export const getHospitalNewsOne = (id: number, locale?: string) => {
  let url = `${SUBBASEURL}/hospitalNews/${id}`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};
